export function initScrollToTop() {
    const btn = document.querySelector('.scroll-to-top');
    if (!btn) return;

    const threshold = window.innerHeight * 0.5;

    function onScroll() {
        if (window.scrollY > threshold) {
            btn.classList.add('scroll-to-top--visible');
        } else {
            btn.classList.remove('scroll-to-top--visible');
        }
    }

    window.addEventListener('scroll', onScroll, { passive: true });

    btn.addEventListener('click', () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    });
}
